<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 60px">
        <P style="font-size: 18px">账户余额：{{ userLeft }}</P>
        <P>
          <v-btn flat color="primary" @click="rechargeInfo.activated = true"
            >充值钱包</v-btn
          >
        </P>
      </v-card-title>
      <v-layout column>
        <v-layout justify-center>
          <v-btn
            flat
            color="primary"
            v-if="!showDetails"
            @click="showDetails = !showDetails"
            >查看钱包明细</v-btn
          >
          <v-btn
            flat
            color="primary"
            v-if="showDetails"
            @click="showDetails = !showDetails"
            >隐藏钱包明细</v-btn
          >
        </v-layout>
        <l-data-table
          v-if="showDetails"
          :get-data-func="type === 'use' ? getUserBillList : getUserPayList"
          :headers="type === 'use' ? header_use : header_pay"
          hide-title-search
          clickable
        >
          <template slot="title">
            <span class="pl-2 pr-4">钱包明细</span>
            <v-radio-group mandatory row v-model="type">
              <v-radio :value="'use'" label="账单记录"></v-radio>
              <v-radio :value="'pay'" label="充值记录"></v-radio>
            </v-radio-group>
          </template>
        </l-data-table>
      </v-layout>
    </v-card>
    <v-dialog width="350px" v-model="rechargeInfo.activated" persistent>
      <v-layout column justify-center>
        <v-card>
          <v-subheader>钱包充值</v-subheader>
          <v-form ref="rechargeForm" class="pa-3" v-if="!loading">
            <v-layout column>
              <v-flex xs12>
                <v-select
                  :items="rechargeInfo.rechargeItems"
                  item-text="value"
                  item-value="value"
                  v-model="rechargeInfo.rechargeSelect"
                  label="充值金额选择"
                  prepend-icon="mdi-currency-usd"
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="rechargeInfo.rechargeSelect === '其他'">
                <v-text-field
                  label="请填写充值金额"
                  prepend-icon="mdi-currency-usd"
                  v-model="rechargeInfo.amount"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-container align-center fill-height v-else>
            <v-layout align-center class="pt-4" column style="height: 200px">
              <v-progress-circular
                :color="'accent'"
                :value="100"
                size="50"
                indeterminate
              ></v-progress-circular>
              <!--<v-btn @click="goTo()">跳转</v-btn>-->
              <span class="pt-3" style="font-size: 20px">正在创建订单...</span>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="error" @click="rechargeInfo.activated = false"
                >取消</v-btn
              >
              <v-btn color="primary" @click="" :loading="loading">提交</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
export default {
  name: "userDetails",
  components: { LDataTable },
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      header_use: [
        {
          text: "创建时间",
          value: "creationTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        { text: "支付金额", value: "payAmount", sortable: true, align: "left" },
        { text: "支付时间", value: "payTime", sortable: false, align: "left" },
      ],
      header_pay: [
        {
          text: "创建时间",
          value: "creationTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "充值金额",
          value: "rechAmount",
          sortable: true,
          align: "left",
        },
        {
          text: "充值时间",
          value: "rechTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        { text: "充值方式", value: "rechMode", sortable: false, align: "left" },
      ],
      userLeft: "",
      showDetails: false,
      type: "use",
      loading: false,
      rechargeInfo: {
        amount: "",
        activated: false,
        rechargeItems: [
          { isSelect: false, value: "20" },
          { isSelect: false, value: "50" },
          { isSelect: false, value: "100" },
          { isSelect: false, value: "200" },
          { isSelect: false, value: "其他" },
        ],
        rechargeSelect: "",
      },
    };
  },
  created() {
    this.init(this.formData);
  },
  methods: {
    init(data) {
      this.userLeft = data.balance;
    },
    getUserInfo() {
      return JSON.parse(sessionStorage.getItem("loginInfo"));
    },
    async getUserBillList({ pagination, sortStack, filterItems = [], search }) {
      try {
        let { items, amount } = await this.$store.dispatch(
          "pay/getUserBillList",
          {
            pagination,
            sortStack,
            filter: filterItems,
            search: { key: "userId", value: this.formData.id },
          }
        );
        return { items: items, amount: amount };
      } catch (e) {}
    },
    async getUserPayList({ pagination, sortStack, filterItems = [], search }) {
      try {
        let { items, amount } = await this.$store.dispatch(
          "pay/getUserPayList",
          {
            pagination,
            sortStack,
            filter: filterItems,
            search: { key: "userId", value: this.formData.id },
          }
        );
        // console.log(items)
        return { items: items, amount: amount };
      } catch (e) {}
    },
    // getDetails(item) {
    //   let selectionString = document.getSelection().toString();
    //   if (!selectionString) {
    //     if (this.type === "use") {
    //       this.$router.push({
    //         name: "useDetailBox",
    //         query: { billId: item.billId },
    //       });
    //     }
    //   }
    // },
    // async getUserDetail() {
    //   let params = {
    //     searchParam: {
    //       userId: {
    //         index: "1",
    //         order: "DESC",
    //         operators: [
    //           {
    //             keyword: this.getUserInfo().id,
    //             operator: "EQ",
    //             matchType: "NONE",
    //           },
    //         ],
    //       },
    //     },
    //   };
    //   try {
    //     let res = await this.$store.dispatch("pay/getUserInfo", params);
    //     if (res.data.status + "" === "200") {
    //       if (res.data.data.content.length === 0) {
    //         this.$L.alert("error", { message: "未查询到该用户" });
    //         return;
    //       } else {
    //         this.userLeft = res.data.data.content[0].balance;
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
  },
};
</script>

<style scoped>
</style>
